import {
  Box,
  Column,
  Columns,
  IconChevron,
  Stack,
  Text,
} from 'braid-design-system';
import type { ReactNode } from 'react';

import type { Partner } from 'src/types';

import {
  GoldTitle,
  KeyMiddlewareTitle,
  PlatinumTitle,
  SilverTitle,
} from './titles';

import * as styles from './CustomAccordion.css';

const titleMap: Partial<Record<Partner['tier'], ReactNode>> = {
  PLATINUM_PARTNERS: <PlatinumTitle />,
  GOLD_PARTNERS: <GoldTitle />,
  SILVER_PARTNERS: <SilverTitle />,
  KEY_MIDDLEWARE_PARTNERS: <KeyMiddlewareTitle />,
};

interface Props {
  label: string;
  expanded: boolean;
  onToggle: () => void;
  disabled?: boolean;
  children: React.ReactElement | null;
  showOnDesktop?: boolean;
  tier: Partner['tier'];
}

export const CustomAccordion = ({
  label,
  expanded,
  onToggle,
  disabled,
  children,
  tier,
}: Props) => {
  const isEmpty = children === null;

  const tierTitle = titleMap[tier];

  return (
    <Box paddingBottom={expanded ? 'xlarge' : 'none'}>
      <Stack space="medium">
        <Box
          {...(!disabled && { onClick: onToggle, className: styles.toggle })}
        >
          <Columns space="none" alignY="center">
            <Column>
              {tierTitle ? (
                tierTitle
              ) : (
                <Text
                  size="standard"
                  weight="medium"
                  tone={
                    (expanded && 'neutral') ||
                    (disabled && 'secondary') ||
                    'link'
                  }
                >
                  <span
                    className={isEmpty ? undefined : styles.link}
                    role="heading"
                    aria-level={3}
                  >
                    {label}
                  </span>
                </Text>
              )}
            </Column>
            {!disabled ? (
              <Column width="content">
                <IconChevron
                  tone="link"
                  size="large"
                  direction={expanded ? 'up' : 'down'}
                />
              </Column>
            ) : null}
          </Columns>
        </Box>
        {expanded ? <Box paddingTop="small">{children}</Box> : null}
      </Stack>
    </Box>
  );
};
